<template>
	<div class="index">
		<div class="flex">
			<div class="my-left">
				<article class="my-left-c01">
					<div class="left-head"><img
							:src="user.user ? user.user.ImgStr : require('../../image/p-head.png')" /></div>
					<div class="left-name">
						{{ user.user ? user.user.Name : '' }}（ID:{{ user.user ? user.user.Number : '' }}）
					</div>
					<div class="left-edit">
						<span>{{ user.user ? user.user.Province : '' }}/{{ user.user ? user.user.Gender : '' | gender }}</span>
						<img src="../../image/p-pencil.png" @click="goDatum()" />
					</div>
					<div class="left-btn">
						<button @click="goMyIndex()">我的服务中心</button>
						<button @click="goSystem()">绑定系统卡</button>
						<button @click="goVip()" v-if="CardSale" class="yellow">开通VIP</button>
					</div>
				</article>
				<article class="my-left-c02">
					<ul class="left-nav">
						<li :class="{ 'on-nav': $route.fullPath.includes('/service') }" @click="goMyIndex()">系统首页</li>
						<!-- 2.22 -->
						<li :class="{ 'on-nav': $route.fullPath.includes('/myUse') }" @click="jieTo()">使用介绍</li>
						<!--4期删除 <li :class="{ 'on-nav': $route.fullPath.includes('/guanZhu') }" @click="goGuan()">我的关注</li> -->
						<!-- 2.22 -->
						<li :class="{ 'on-nav': $route.fullPath.includes('/system') }" @click="xiTongTo()">绑定系统卡</li>
						<li :class="{ 'on-nav': $route.fullPath.includes('/report') }" @click="goReport()">我的报告</li>
						<li :class="{ 'on-nav': $route.fullPath.includes('/datum') }" @click="goDatum()">个人资料</li>
						<!-- 2.22 -->
						<li :class="{ 'on-nav': $route.fullPath.includes('/myRecord') }" @click="gouMaiTo()">购买服务记录</li>
						<li :class="{ 'on-nav': $route.fullPath.includes('/safety') }" @click="goSafety()">安全中心</li>
					</ul>
					<div class="left-btn">
						<div class="left-exit-btn" @click="logout">退出登录</div>
					</div>
				</article>
			</div>
			<div class="my-right">
				<router-view></router-view>
			</div>
		</div>
		<!-- 5.30 -->
		<aside class="popup flexCenter" v-if="isHtmlPop">
			<div class="bai_div">
				<i class="el-icon-close" @click="isHtmlPop = false"></i>
				<div class="bai_box">
					<img src="../../image/AI-banner.png" />
				</div>
			</div>
		</aside>
	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex';

	export default {
		name: 'index',
		data() {
			return {
				isHtmlPop: false,
				CardSale: false
			};
		},
		computed: {
			...mapState(['user'])
		},
		mounted: function() {
			this.GetCardSet();
		},
		methods: {
			jieTo() {
				this.$router.push('/myUse');
			},
			xiTongTo() {
				this.$router.push('/system');
			},
			gouMaiTo() {
				this.$router.push('/myRecord');
			},
			// 2.22
			// 登录
			logout() {
				this.$confirm('您确定要退出账号吗?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						this.$store.dispatch('user/logout');
						this.$util.showOk('登出成功');
						this.$router.push('/home');
					})
					.catch(() => {});
			},
			// 我的报告
			goReport() {
				this.$router.push('/report');
			},
			// 系统首页
			goMyIndex() {
				this.$router.push('/service');
			},
			goGuan() {
				this.$router.push('/guanZhu');
			},
			// 我的资料
			goDatum() {
				this.$router.push('/datum');
			},
			// 安全中心
			goSafety() {
				this.$router.push('/safety');
			},
			// 退出
			login() {
				this.$router.push('/login');
			},
			goSystem() {
				this.$router.push('/system');
			},
			goVip() {
				this.$router.push('/vip');
			},
			// 获取销售卡配置
			GetCardSet: function() {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/GetWebSet',
					'GET', {},
					function(res) {
						console.log('获取销售卡配置');
						console.log(res);
						if (res.code === 0) {
							that.CardSale = res.data.CardSale;
							that.$store.state.user.cardSaleStatus = res.data.CardSale;
						}
					},
					function(res) {}
				);
			}
		}
	};
</script>
<style lang="scss" scoped>
	.bai_box img {
		display: block;
		max-width: 100%;
	}

	.bai_box {
		height: calc(100% - 70px);
		overflow: auto;
		width: 95%;
		margin: 40px auto 0 auto;
	}

	.bai_div i {
		font-size: 32px;
		color: #000;
		position: absolute;
		right: 10px;
		top: 10px;
		margin: 0;
		z-index: 1;
		cursor: pointer;
	}

	.bai_div {
		background-color: #fff;
		border-radius: 20px;
		width: 800px;
		height: 65vh;
		position: relative;
	}

	.yellow {
		background: -webkit-linear-gradient(left, #ffb019, #ff7c04);
		/* Safari 5.1 - 6.0 */
		background: -o-linear-gradient(right, #ffb019, #ff7c04);
		/* Opera 11.1 - 12.0 */
		background: -moz-linear-gradient(right, #ffb019, #ff7c04);
		/* Firefox 3.6 - 15 */
		background: linear-gradient(to right, #ffb019, #ff7c04);
		color: #fff !important;
	}

	.index {
		margin: 20px auto;
		width: 1200px;
		height: auto;
	}

	.my-left {
		width: 240px;
		height: auto;
		overflow: hidden;
		margin-right: 20px;
	}

	.my-left-c01 {
		width: 100%;
		height: auto;
		background: #fff;
		overflow: hidden;
		padding-bottom: 30px;
		margin-bottom: 20px;
	}

	.left-head {
		margin: 40px auto;
		width: 100px;
		height: 100px;
		border-radius: 50%;
		background: url(../../image/p-head.png) no-repeat;
		background-size: 100% 100%;
	}

	.left-head img {
		width: 100%;
		height: 100%;
		display: block;
		border-radius: 50%;
	}

	.left-name {
		width: 100%;
		text-align: center;
		font-size: 16px;
		color: #333;
	}

	.left-edit {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 20px 0;
	}

	.left-edit span {
		font-size: 16px;
		color: #999;
	}

	.left-edit img {
		width: 20px;
		height: 20px;
		display: block;
		margin-left: 15px;
		cursor: pointer;
	}

	.left-btn {
		padding: 0 20px;
		height: auto;
		overflow: hidden;
	}

	.left-btn button {
		width: 100%;
		height: 40px;
		line-height: 38px;
		text-align: center;
		font-size: 14px;
		border-radius: 6px;
		margin-bottom: 10px;
		cursor: pointer;
	}

	.left-btn button:first-child {
		border: 1px solid #dddddd;
		color: #333;
		background: #fff;
	}

	.left-btn button:nth-child(2) {
		border: 1px solid #333;
		color: #fff;
		background: #333;
	}

	// my-left-c02
	.my-left-c02 {
		width: 100%;
		height: auto;
		overflow: hidden;
		background: #fff;
	}

	.left-nav {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.left-nav li {
		padding-left: 30px;
		text-align: left;
		font-size: 16px;
		color: #333;
		height: 50px;
		line-height: 50px;
		position: relative;
		cursor: pointer;
	}

	.left-nav .on-nav {
		background: rgba(0, 0, 0, 0.6);
		color: #fff;
	}

	.left-nav .on-nav::after {
		position: absolute;
		content: '';
		width: 2px;
		height: 50px;
		background: #333;
		left: 0;
		top: 0;
	}

	.left-exit-btn:hover {
		opacity: 0.7;
	}

	.left-exit-btn {
		cursor: pointer;
		margin-top: 20px;
		margin-bottom: 30px;
		width: 100%;
		height: 40px;
		line-height: 38px;
		text-align: center;
		font-size: 16px;
		color: #de443b;
		border-radius: 6px;
		border: 1px solid #f2b4b1;
	}

	.my-right {
		width: 940px;
		height: auto;
		background: #fff;
	}
</style>
